module.exports = __webpack_public_path__ + "static/media/uoa-14.fab22e5e.jpg";